@if (landLineList.length > 1 && visibility) {
  <div class="modal-lines-list" id="list-wrapper">
    <div id="content" class="text-center">
      <div class="search-field">
        <input type="text" placeholder="Nom/Prénom/N°" (keyup)="filter($event)">
      </div>
      <ul class="list-group">
        @for (landLine of landLineListCopy; track landLine) {
          <li class="list-group-item" (click)="setSelectedLine(landLine.phoneNumber)">
            <div>
              <app-dot [dynamicStatus]="landLine.status"></app-dot>
              <p>{{ landLine.phoneNumber }}</p>
                @if (landLine.comment && landLine.comment.length > 0) {
                    <span>: {{ landLine.comment }}</span>
                } @else {
                    <span></span>
                }
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
}
@if (landLineList.length > 1 && visibility) {
  <div class="modal-lines-list-background" (click)="closeLinesList($event)"></div>
}
